module.exports = __webpack_public_path__ + "static/6-723fd421265a822f3701643eba67cd61.jpg";